import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Spin } from 'antd';

import { useAppDispatch } from 'hooks/useAppDispatch';
import BaseAlert from 'components/wrappers/BaseAlert/BaseAlert';
import { maintenanceAccessCode } from 'constants/MaintenanceConfig';
import { MaintenanceModeContext } from 'components/MaintenanceModeProvider';

type ParamsProps = {
  code: string;
};

export default function MaintenanceAccessPage() {
  const { code } = useParams<ParamsProps>();
  const [isLoading, setIsLoading] = useState(false);
  const { setIsMaintenanceMode } = useContext(MaintenanceModeContext);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!code) {
      return navigate('/maintenance', { replace: true });
    }

    const checkAndSetMaintenanceAccessCode = async () => {
      setIsLoading(true);

      const isCodeValid = maintenanceAccessCode === code;

      if (isCodeValid) {
        setIsMaintenanceMode(false);
        BaseAlert.success('Access is granted.');
      } else {
        navigate('/maintenance', { replace: true });
        BaseAlert.error('The access code is invalid.');
      }
      setIsLoading(false);
    };

    checkAndSetMaintenanceAccessCode();
    // eslint-disable-next-line
  }, [dispatch, code]);

  return <>{isLoading && <Spin />}</>;
}
